import { call, put, takeLatest } from 'redux-saga/effects';
import { t } from 'i18next';

import { Api } from '../../../entries/ApiTransport';
import sagaAssessor from '../../../utils/sagaAssessor';
import { reviewsTypes, reviewsActions } from './actions';
import { toastActions } from 'Containers/Toasts/store';
import { getDemoReviewsPayload } from 'demo';
import { getLiveDemoBundle, selectIsDemoMode } from 'demo/saga';
import { markReviewReported } from 'demo/session';

const api = Api.getInstance();

const getReviews = ({ payload, options } = {}) =>
  sagaAssessor(
    () =>
      function* () {
        if (yield* selectIsDemoMode()) {
          const bundle = yield* getLiveDemoBundle();
          yield put(reviewsActions.GET_REVIEWS.SUCCESS(getDemoReviewsPayload(bundle)));
          return;
        }
        const params = new URLSearchParams();
        if (payload?.dataInizio) params.set('dataInizio', payload.dataInizio);
        if (payload?.dataFine) params.set('dataFine', payload.dataFine);
        const query = params.toString();
        const { data } = yield call(() =>
          api.get(`/business/review/getReviews${query ? `?${query}` : ''}`),
        );
        yield put(
          reviewsActions.GET_REVIEWS.SUCCESS({
            reviews: data?.reviews || [],
            averageRating: data?.averageRating || 0,
            totalReviews: data?.totalReviews || 0,
            totalRatings: data?.totalRatings ?? data?.totalReviews ?? 0,
            ratingDistribution: data?.ratingDistribution || {},
          }),
        );
      },
    (err) => reviewsActions.GET_REVIEWS.FAILED(err),
    options,
  );

const reportReview = ({ payload, callback }) =>
  sagaAssessor(
    () =>
      function* () {
        if (yield* selectIsDemoMode()) {
          markReviewReported(payload.idReview);
          yield put(reviewsActions.REPORT_REVIEW.SUCCESS({ reviewId: payload.idReview }));
          callback?.();
          yield put(
            toastActions.OPEN_TOAST.SUCCESS({
              type: 'review',
              props: { title: t('common.toastMessages.reviewReported') },
            }),
          );
          return;
        }
        yield call(() => api.post('/business/review/report', payload));
        yield put(reviewsActions.REPORT_REVIEW.SUCCESS({ reviewId: payload.idReview }));
        callback?.();
        yield put(
          toastActions.OPEN_TOAST.SUCCESS({
            type: 'review',
            props: { title: t('common.toastMessages.reviewReported') },
          }),
        );
      },
    (err) => reviewsActions.REPORT_REVIEW.FAILED(err),
  );

export default function* () {
  yield takeLatest(reviewsTypes.GET_REVIEWS.REQUEST, getReviews);
  yield takeLatest(reviewsTypes.REPORT_REVIEW.REQUEST, reportReview);
}

